"use client";

import React, { useEffect, useState } from "react";

function BackToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Show or hide the button based on scroll position
    const toggleVisibility = () => {
        if (window.scrollY > 1000) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, []);

    useEffect(() => {
        // Prevent keyboard-focused elements from being obscured by this fixed button (WCAG 2.4.11)
        document.documentElement.style.scrollPaddingBottom = isVisible ? "120px" : "";
        return () => {
            document.documentElement.style.scrollPaddingBottom = "";
        };
    }, [isVisible]);

    return (
        <a
            id="back_to_top"
            className={`fixed bottom-[65px] right-[25px] z-[10000] transition-all duration-300 ease-in-out ${
                isVisible ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
            onClick={scrollToTop}
            aria-label="Back to top"
        >
            {/* Button container */}
            <span
                className="
                    flex items-center justify-center
                    w-[54px] h-[54px]
                    rounded-full
                    border-[1px] border-solid border-topBlue
                    bg-topBlue
                    hover:bg-topBlue hover:border-topBlue
                    transition-all duration-300 ease-in-out
                    shadow-md text-2.5xl"
            >
                {/* FontAwesome arrow */}
                <i className="fa fa-arrow-up text-white leading-none"></i>
            </span>
        </a>
    );
}

export default BackToTop;
